// EmptyState — generic zero-results placeholder
// Session 3

import React from 'react';

interface Props {
  heading: string;
  body?: string;
  action?: { label: string; onClick: () => void };
}

export function EmptyState({ heading, body, action }: Props) {
  return (
    <div style={wrapStyle}>
      <div style={iconWrap}>
        <WaveformIcon />
      </div>
      <p style={headingStyle}>{heading}</p>
      {body && <p style={bodyStyle}>{body}</p>}
      {action && (
        <button onClick={action.onClick} style={actionStyle}>
          {action.label}
        </button>
      )}
    </div>
  );
}

function WaveformIcon() {
  return (
    <svg width={32} height={32} viewBox="0 0 24 24" fill="none" stroke="var(--text-muted)" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
      <line x1="2"  y1="12" x2="2"  y2="12" />
      <line x1="6"  y1="8"  x2="6"  y2="16" />
      <line x1="10" y1="5"  x2="10" y2="19" />
      <line x1="14" y1="9"  x2="14" y2="15" />
      <line x1="18" y1="7"  x2="18" y2="17" />
      <line x1="22" y1="12" x2="22" y2="12" />
    </svg>
  );
}

const wrapStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '60px 24px',
  textAlign: 'center',
};

const iconWrap: React.CSSProperties = {
  width: 56,
  height: 56,
  borderRadius: '50%',
  background: 'var(--surface2)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: 16,
};

const headingStyle: React.CSSProperties = {
  fontSize: 15,
  fontWeight: 600,
  color: 'var(--text)',
  marginBottom: 6,
};

const bodyStyle: React.CSSProperties = {
  fontSize: 13,
  color: 'var(--text-muted)',
  lineHeight: 1.6,
  maxWidth: 280,
};

const actionStyle: React.CSSProperties = {
  marginTop: 16,
  padding: '9px 20px',
  borderRadius: 100,
  background: 'var(--accent)',
  color: '#fff',
  fontSize: 13,
  fontWeight: 600,
  cursor: 'pointer',
};
